import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input } from "reactstrap";
import styles from 'assets/scss/task_management.module.css';
import { Trans } from 'react-i18next';
import { FaTimes } from 'react-icons/fa';
import { PayrollClient } from "services";
import { NotificationManager } from "react-notifications";

const RequestModal = ({ isOpen, action, onClose, onSubmit, selectedOrganisation, onReassign, userPermission, t }) => {
  const [reason, setReason] = useState("");
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [errors, setErrors] = useState({ employees: "", reason: "" });
  const [searchKeyword, setSearchKeyword] = useState('');
  const [employees, setEmployees] = useState([]);
  const client = PayrollClient();

  useEffect (() => {
    fetchEmployees();
  }, []);

  const fetchEmployees = async () => {
    try {
        const response = await client.get(`/employees-list-for-task`);
        const data = response.data;
        setEmployees(data);
    } catch (error) {
        console.error("Error fetching data:", error);
    }
};

    const handleReassign = () => {
        let hasError = false;
        const newErrors = { employees: "", reason: "" };

        if (action === "approve") {
          if (selectedEmployees?.length === 0) {
            newErrors.employees = "Please select at least one employee.";
            hasError = true;
        }
        }
        if (reason.trim() === "") {
            newErrors.reason = "Please provide a reason for reassignment.";
            hasError = true;
        }

        if (hasError) {
            setErrors(newErrors);
            return;
        }

        onSubmit(selectedEmployees, reason);
        setReason("");
        setSelectedEmployees([]);
    };
    const handleEmployeeSelect = (employeeId) => {
      if (selectedEmployees.includes(employeeId)) {
          setSelectedEmployees(selectedEmployees?.filter(id => id !== employeeId));
      } else {
          setSelectedEmployees([...selectedEmployees, employeeId]);
      }
  };
  const handleRemoveEmployee = (employeeId) => {
    setSelectedEmployees(selectedEmployees?.filter(id => id !== employeeId));
  };

  return (
    <Modal isOpen={isOpen} toggle={onClose}>
      <ModalHeader toggle={onClose}>{action === 'approve' ? t('Approve') : t('Reject')} <Trans>Request</Trans></ModalHeader>
      <ModalBody>
        {action === "approve" && (
          <div className={styles.formGroup}>
            <label><Trans>Re-assign to Employees</Trans></label>
            <div className={styles.dropdownContent}>
                <div className={styles.notes_area}>
                    <input
                        type="text"
                        placeholder="Search Employees"
                        value={searchKeyword}
                        onChange={(e) => setSearchKeyword(e.target.value)}
                        className={styles.search_employee}
                    />
                </div>
                {selectedEmployees?.length > 0 && (
                    <>
                        <div className={styles.assignedEmployees}><strong><Trans>Assigned</Trans></strong></div>
                        {selectedEmployees?.map(employeeId => (
                            <button key={employeeId} className={styles.assignedEmployee}>
                                {employees?.find(employee => employee?.id === employeeId)?.full_name} 
                                <FaTimes onClick={() => handleRemoveEmployee(employeeId)} />
                            </button>
                        ))}
                    </>
                )}
                <div className={styles.suggestions}><strong><Trans>Suggestions</Trans></strong></div>
                {employees
                    ?.filter(employee => !selectedEmployees.includes(employee?.id) && employee?.full_name?.toLowerCase().includes(searchKeyword.toLowerCase()))
                    .map((employee, index) => (
                        <button
                            key={employee?.id}
                            className={styles.suggestion}
                            onClick={() => {
                                handleEmployeeSelect(employee?.id);
                                setSearchKeyword("");
                            }}
                        >
                            {employee?.full_name}
                        </button>
                    ))}
            </div>
            {errors?.employees && <span style={{color:"red"}}>{errors?.employees}</span>}
        </div>
        )}
        <Input
          type="textarea"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder={`Enter reason for ${action}`}
        />
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleReassign}>{action === 'approve' ? t('Approve') : t('Reject')}</Button>
        <Button color="secondary" onClick={onClose}><Trans>Cancel</Trans></Button>
      </ModalFooter>
    </Modal>
  );
};

export default RequestModal;